export default __webpack_public_path__ + "static/media/EditFacilityCardIcon.c4bc015d.svg";